import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import type { MatrixRow } from './types'

const COLORS: Record<string, string> = {
  Китай: '#3b82f6',
  Производители: '#10b981',
  РФ: '#8b5cf6',
  Стоки: '#f59e0b',
  Склад: '#64748b',
}

function colorFor(name: string): string {
  if (COLORS[name]) return COLORS[name]
  return '#94a3b8'
}

export function MatricesPieChart({ matrices }: { matrices: MatrixRow[] }) {
  const total = matrices.reduce((a, m) => a + m.count, 0)
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full flex flex-col">
      <div className="flex items-center justify-between gap-2 mb-2">
        {/* Название по решению Сергея 19.09.2026: прежние «Матрицы закупок»
            читались как «ушло в заказ», а блок показывает позиции в работе. */}
        <div className="text-sm text-gray-500">Позиции в работе по матрицам</div>
        <span
          className="text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded bg-amber-50 text-amber-700 border border-amber-200"
          title="Блок в MVP показывает только распределение по матрицам; детальная аналитика по марже/выручке на матрицу — после релиза"
        >
          MVP
        </span>
      </div>

      {total === 0 ? (
        <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
          Нет данных за период
        </div>
      ) : (
        <>
          <div className="flex-1 min-h-[180px]">
            <ResponsiveContainer width="100%" height="100%" minHeight={120}>
              <PieChart>
                <Pie
                  data={matrices}
                  dataKey="count"
                  nameKey="name"
                  innerRadius="55%"
                  outerRadius="85%"
                  paddingAngle={2}
                >
                  {matrices.map((m) => (
                    <Cell key={m.name} fill={colorFor(m.name)} />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(v, _n, p) => {
                    const payload = (p as { payload?: MatrixRow })?.payload
                    return [`${Number(v)} поз. (${payload?.percent ?? 0}%)`, payload?.name ?? '']
                  }}
                  contentStyle={{
                    borderRadius: 8,
                    border: '1px solid #e5e7eb',
                    fontSize: 12,
                  }}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div className="grid grid-cols-2 gap-x-3 gap-y-1.5 mt-3">
            {matrices.map((m) => (
              <div key={m.name} className="flex items-center justify-between gap-2 text-xs">
                <span className="flex items-center gap-1.5 min-w-0">
                  <span
                    className="w-2.5 h-2.5 rounded-sm shrink-0"
                    style={{ backgroundColor: colorFor(m.name) }}
                  />
                  <span className="truncate text-gray-700">{m.name}</span>
                </span>
                <span className="tabular-nums text-gray-500 shrink-0">{m.percent}%</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
